import React, { useEffect, useState }  from 'react';
import PropTypes from "prop-types";
import axios from "axios";
import Modal from 'react-bootstrap/Modal';
import Swal from 'sweetalert2'

export const Add = ({type, show, setShow, handleClose, getList, editId, setEditId, ...rest}) => {    
    const [form, setForm] = useState({
        id: editId,
        amount: '',
        percent: ''
    });

    useEffect(() => {
        if(editId > 0){
            axios.get(`api/singleDiscount?id=${editId}`).then(res => {
                console.log(res);
                if(res.data.success){
                    setForm({...form, id: editId, amount: res.data.data.amount, percent: res.data.data.percent})
                }
            })
        }
        else{
            setForm({...form, id: editId, amount: '', percent: ''})
        }
        
    },[editId]);
    
    const handleSave = () =>{
        if(editId > 0){
            axios.put(`api/discounts/update`, form).then(res => {
                if(res.data.success){
                    setShow(false);                    
                    Swal.fire(res.data.message, '', 'success').then(result => {
                        getList();                        
                    })
                } 
                else{
                    Swal.fire(res.data.message, '', 'error')
                }
            }).catch((error) => {
                // console.log(error.response.data)
                Swal.fire(error.response.data.message, '', 'error')
            });
        }
        else{
            axios.post(`api/discounts/create`, form).then(res => {
                if(res.data.success){
                    setShow(false);
                    Swal.fire(res.data.message, '', 'success').then(result => {
                        getList();
                        setForm({amount: '', percent: ''})
                    })                
                } 
                else{
                    Swal.fire(res.data.message, '', 'error')
                }
            }).catch((error) => {
                // console.log(error.response.data)
                Swal.fire(error.response.data.message, '', 'error')
            });
        }        
    }
    return (
        <Modal show={show} onHide={handleClose} dialogClassName="modal-md" style={{zIndex: 9999}}>
            <Modal.Header>
                <h5 className="modal-title">{type} Discount</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className="form-group">
                    <label htmlFor="">Amount (₹)</label>
                    <input name="amount" type="text" className="form-control" value={form.amount} onChange={(e) => setForm({...form, amount: e.target.value})}/>
                </div>
                <div className="form-group">
                    <label htmlFor="">Percent (%)</label>
                    <input name="percent" type="text" className="form-control" value={form.percent } onChange={(e) => setForm({...form, percent : e.target.value})}/>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="r-btn r-btn-base" onClick={handleClose}>Close</button>
                <button type="button" onClick={handleSave} className="r-btn r-btn-primary">{type == 'Add' ? 'Add' : 'Update'}</button>
            </Modal.Footer>
        </Modal>
    );
}

export default Add;
Add.propTypes = {
    type: PropTypes.string.isRequired,
    show: PropTypes.bool.isRequired,
    setShow: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired    
};